import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path d="M27.3,27.276A3.464,3.464,0,0,1,25,28a3.478,3.478,0,0,1-2.293-.707A5.307,5.307,0,0,0,19,26,5.306,5.306,0,0,0,15.3,27.276,3.464,3.464,0,0,1,13,28a3.478,3.478,0,0,1-2.293-.707A5.307,5.307,0,0,0,7,26a5.305,5.305,0,0,0-3.707,1.293.992.992,0,0,0-.006,1.4,1.007,1.007,0,0,0,1.408.03A3.457,3.457,0,0,1,7,28a3.479,3.479,0,0,1,2.293.707A5.305,5.305,0,0,0,13,30a5.309,5.309,0,0,0,3.7-1.281A3.455,3.455,0,0,1,19,28a3.479,3.479,0,0,1,2.293.707A5.305,5.305,0,0,0,25,30,5.307,5.307,0,0,0,28.706,28.7a.994.994,0,0,0,.006-1.4A1.006,1.006,0,0,0,27.3,27.276Z"/><path d="M26.735,14.589a1.165,1.165,0,0,0,1.47-.741,1.219,1.219,0,0,0,.038-.147c.584-4.635-2.46-9.225-7.329-10.979l.011-.042a1,1,0,1,0-1.932-.518l-.01.039C13.865,1.251,8.9,3.705,7.077,8.03a1.163,1.163,0,0,0,.717,1.482,1.2,1.2,0,0,0,.145.04l8.466,2.269L13.946,21H10a2.916,2.916,0,0,0-3,2.829Q7,23.91,7,24a.994.994,0,0,0,.987.993H8a1.007,1.007,0,0,0,1-.981A.917.917,0,0,1,9.813,23,.89.89,0,0,1,10,23H26a1,1,0,0,0,0-2H16.017l2.319-8.656Z"/>';
export var VacationSVG = function VacationSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
VacationSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(VacationSVG);